import { Component } from '@angular/core';

@Component({
  selector: 'lib-library',
  template: `
    <p>
      library works!
    </p>
  `,
  styles: [
  ]
})
export class LibraryComponent {

}
